export default __webpack_public_path__ + "static/media/pulsechain-logo.d32a677f.png";